import React from "react";
import Box from "@mui/material/Box";
import TabelBarang from "../../components/TabelBarang/TabelBarang";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import { useAuthStore } from "../../stores/authStore";
import moment from "moment";
import "moment/locale/id";
import StokBarangModals from "./components/StokBarangModals";
import useStokBarangPageData from "./hooks/useStokBarangPageData";
import useStokBarangModals from "./hooks/useStokBarangModals";

moment.locales();
moment.locale("id");

const StokBarang = () => {
    const ukmIdUser = useAuthStore((s) => s.ukmIdUser);
    const ukmIdFromAuth = ukmIdUser && ukmIdUser[0];
    const { isUkmTidakAktif, noAccessStok, refetchKategori, ukmData } =
        useStokBarangPageData(ukmIdFromAuth);
    const {
        deleteKategoriState,
        editKategoriState,
        handleCloseDeleteKategori,
        handleCloseEditKategori,
        handleCloseModalImport,
        handleCloseModalKatalog,
        handleCloseModalKategori,
        handleCloseModalMutasi,
        handleClosePrintBarcode,
        handleOpenDeleteKategori,
        handleOpenEditKategori,
        handleOpenModalImport,
        handleOpenModalKatalog,
        handleOpenModalKategori,
        handleOpenModalMutasi,
        handleOpenPrintBarcode,
        isModalImportOpen,
        isModalKatalogOpen,
        isModalKategoriOpen,
        isModalMutasiOpen,
        printBarcodeState,
    } = useStokBarangModals();

    if (noAccessStok) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    if (ukmData && isUkmTidakAktif) {
        return <TokoTidakAktif namaToko={ukmData.namaToko} />;
    }

    return (
        <Box>
            <TabelBarang
                onOpenKategori={handleOpenModalKategori}
                onOpenKatalog={handleOpenModalKatalog}
                onOpenImport={handleOpenModalImport}
                onOpenMutasi={handleOpenModalMutasi}
                onOpenPrintBarcode={handleOpenPrintBarcode}
            />
            <StokBarangModals
                deleteKategoriState={deleteKategoriState}
                editKategoriState={editKategoriState}
                isModalImportOpen={isModalImportOpen}
                isModalKatalogOpen={isModalKatalogOpen}
                isModalKategoriOpen={isModalKategoriOpen}
                isModalMutasiOpen={isModalMutasiOpen}
                namaToko={ukmData?.namaToko}
                onCloseDeleteKategori={handleCloseDeleteKategori}
                onCloseEditKategori={handleCloseEditKategori}
                onCloseImport={handleCloseModalImport}
                onCloseKatalog={handleCloseModalKatalog}
                onCloseKategori={handleCloseModalKategori}
                onCloseMutasi={handleCloseModalMutasi}
                onClosePrintBarcode={handleClosePrintBarcode}
                onOpenDeleteKategori={handleOpenDeleteKategori}
                onOpenEditKategori={handleOpenEditKategori}
                onOpenKategori={handleOpenModalKategori}
                printBarcodeState={printBarcodeState}
                refetchKategori={refetchKategori}
                ukmIsPro={ukmData?.isPro ?? undefined}
            />
        </Box>
    );
};

export default StokBarang;
